module.exports = __webpack_public_path__ + "img/img47.40a9d8d4.png";